/**
 * Base error class per docs/architecture/05-error-handling-strategy.md.
 * Every error surfaced to the UI must be (or be mapped to) an AppError:
 * it carries a machine-readable code plus a human-readable, Persian message,
 * and never leaks raw stack traces or infrastructure details to the user.
 */
export class AppError extends Error {
  public readonly code: string;

  constructor(code: string, message: string, options?: { cause?: unknown }) {
    super(message, options);
    this.name = 'AppError';
    this.code = code;
    Object.setPrototypeOf(this, AppError.prototype);
  }
}
